import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StopChatStreamMutationVariables = Types.Exact<{
  stream_id: Types.Scalars['String']['input'];
}>;


export type StopChatStreamMutation = { __typename?: 'mutation_root', stop_chat_stream?: { __typename?: 'StopChatStreamOutput', success: boolean, stopped: boolean } | null };


export const StopChatStreamDocument = gql`
    mutation stopChatStream($stream_id: String!) {
  stop_chat_stream(stream_id: $stream_id) {
    success
    stopped
  }
}
    `;
export type StopChatStreamMutationFn = Apollo.MutationFunction<StopChatStreamMutation, StopChatStreamMutationVariables>;

/**
 * __useStopChatStreamMutation__
 *
 * To run a mutation, you first call `useStopChatStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopChatStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopChatStreamMutation, { data, loading, error }] = useStopChatStreamMutation({
 *   variables: {
 *      stream_id: // value for 'stream_id'
 *   },
 * });
 */
export function useStopChatStreamMutation(baseOptions?: Apollo.MutationHookOptions<StopChatStreamMutation, StopChatStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopChatStreamMutation, StopChatStreamMutationVariables>(StopChatStreamDocument, options);
      }
export type StopChatStreamMutationHookResult = ReturnType<typeof useStopChatStreamMutation>;
export type StopChatStreamMutationResult = Apollo.MutationResult<StopChatStreamMutation>;
export type StopChatStreamMutationOptions = Apollo.BaseMutationOptions<StopChatStreamMutation, StopChatStreamMutationVariables>;